import { useContext, useEffect, useState } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import AppGlobalsContext from "app/AppGlobalsContext";
import { COUNTRY_WITH_STATE_OR_PROVINCES } from "app/constants";

export const useStateAndProvinces = countryCode => {
	const { track } = useAnalytics();

	const [stateAndProvinces, setStateAndProvinces] = useState([]);

	const { shop } = useContext(AppGlobalsContext);
	const [locale] = shop.split("-");

	useEffect(() => {
		if (locale && COUNTRY_WITH_STATE_OR_PROVINCES.includes(countryCode)) {
			import(`./stateAndProvinces/${countryCode}/${locale}.json`)
				.then(module => {
					let finalStateAndProvinces = [...module.default].sort((a, b) =>
						a.name.localeCompare(b.name, locale)
					);

					setStateAndProvinces(finalStateAndProvinces);
				})
				.catch(error => {
					// eslint-disable-next-line no-console
					console.error(error);
					track("error", { error });
				});
		}
	}, [locale, countryCode]);

	return stateAndProvinces;
};
